import RouteCheckerTo from '@/views/route-checker';
import costHelpTypeView from './cost-help-type.view.vue';

export default [
  {
    path: '/cost-help-types',
    name: 'Ajudas de Custo',
    component: costHelpTypeView,
    beforeEnter: RouteCheckerTo.hasAccessCostHelpType,
  },
];
